/* ============================================
   GHOST LABEL SCENTS — Theme JS
   ============================================ */
(function () {
  'use strict';

  const $ = (s, ctx) => (ctx || document).querySelector(s);
  const $$ = (s, ctx) => [...(ctx || document).querySelectorAll(s)];

  const FREE_SHIPPING_CENTS = 10000; // $100 threshold — keep in sync with templates/cart.liquid

  /* ── NAV DRAWER ─────────────────────────── */
  function initNavDrawer() {
    const btn     = $('#nav-toggle');
    const drawer  = $('#nav-drawer');
    const overlay = $('#nav-overlay');
    const close   = $('#nav-close');
    if (!btn || !drawer) return;
    const open = () => { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; btn.setAttribute('aria-expanded', 'true'); };
    const shut = () => { drawer.classList.remove('open'); document.body.style.overflow = ''; btn.setAttribute('aria-expanded', 'false'); };
    btn.addEventListener('click', open);
    close?.addEventListener('click', shut);
    overlay?.addEventListener('click', shut);
    document.addEventListener('keydown', e => e.key === 'Escape' && shut());
  }

  /* ── HELPERS ─────────────────────────────── */
  function fmtMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function wholeDollarsUp(cents) {
    return '$' + Math.max(0, Math.ceil(cents / 100));
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, (s) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[s]));
  }

  /* ── CART DRAWER ────────────────────────── */
  let cartBusy = false;
  const qtyTimers = {};

  function initCartDrawer() {
    const drawer  = $('#cart-drawer');
    const overlay = $('#cart-overlay');
    const close   = $('#cart-close');
    const body    = $('#cart-body');
    if (!drawer) return;

    window.openCart = (opts) => {
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      drawer.setAttribute('aria-hidden', 'false');
      if (!opts || opts.skipRefresh !== true) refreshCart();
    };
    window.closeCart = () => {
      drawer.classList.remove('open');
      document.body.style.overflow = '';
      drawer.setAttribute('aria-hidden', 'true');
    };

    $$('[data-cart-open]').forEach(el => el.addEventListener('click', (e) => {
      e.preventDefault();
      window.openCart();
    }));
    close?.addEventListener('click', window.closeCart);
    overlay?.addEventListener('click', window.closeCart);
    document.addEventListener('keydown', e => e.key === 'Escape' && window.closeCart());

    // Delegated events for line-item qty +/- and remove — survive innerHTML re-renders
    body?.addEventListener('click', (e) => {
      const minusBtn  = e.target.closest('[data-cart-qty-minus]');
      const plusBtn   = e.target.closest('[data-cart-qty-plus]');
      const removeBtn = e.target.closest('[data-cart-remove]');
      const control = minusBtn || plusBtn || removeBtn;
      if (!control) return;

      const row = control.closest('.cart-item');
      const key = control.getAttribute('data-key');
      if (!key) return;

      if (removeBtn) {
        if (row) row.classList.add('is-updating');
        scheduleQtyChange(key, 0);
        return;
      }

      const valueEl = row?.querySelector('.cart-item-qty-value');
      const current = parseInt(valueEl?.textContent || '1', 10) || 1;
      const next = minusBtn ? Math.max(0, current - 1) : current + 1;

      if (valueEl && next > 0) valueEl.textContent = next; // optimistic UI
      if (row && next === 0) row.classList.add('is-updating');
      scheduleQtyChange(key, next);
    });
  }

  function scheduleQtyChange(key, quantity) {
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(() => changeLine(key, quantity), 300);
  }

  async function changeLine(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart && cart.description || 'Could not update cart');
      renderCart(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (err) {
      console.warn('Cart update failed', err);
      refreshCart(); // resync UI with server truth if something went wrong
    }
  }

  function updateShippingProgress(cart) {
    const total = cart.total_price;
    const remaining = Math.max(0, FREE_SHIPPING_CENTS - total);
    const progress = Math.min((total / FREE_SHIPPING_CENTS) * 100, 100);

    const text = $('#drawer-shipping-text');
    const fill = $('#drawer-shipping-fill');

    if (fill) fill.style.width = progress + '%';

    if (text) {
      text.innerHTML = remaining > 0
        ? `🚚 You're <strong>${wholeDollarsUp(remaining)}</strong> away from <strong>FREE SHIPPING!</strong>`
        : `🎉 You unlocked <strong>FREE SHIPPING!</strong>`;
    }
  }

  function renderCart(cart) {
    const body      = $('#cart-body');
    const totalEl   = $('#cart-total-price');
    const savingsEl = $('#cart-savings');
    if (!body) return;

    $$('.cart-badge').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    });

    updateShippingProgress(cart);

    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      if (totalEl) totalEl.textContent = fmtMoney(0);
      if (savingsEl) savingsEl.style.display = 'none';
      return;
    }

    body.innerHTML = cart.items.map(item => {
      const img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') : '';
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-item-variant">${escapeHtml(item.variant_title)}</p>`
        : '';
      return `
        <div class="cart-item" data-cart-key="${escapeHtml(item.key)}">
          <div class="cart-item-img"><img src="${img}" alt="${escapeHtml(item.product_title)}" loading="lazy"></div>
          <div class="cart-item-content">
            <div class="cart-item-top">
              <div>
                <p class="cart-item-name">${escapeHtml(item.product_title)}</p>
                ${variantTitle}
              </div>
              <button type="button" class="cart-item-remove" data-cart-remove data-key="${escapeHtml(item.key)}" aria-label="Remove ${escapeHtml(item.product_title)}">Remove</button>
            </div>
            <div class="cart-item-bottom">
              <div class="cart-item-qty">
                <button type="button" class="cart-item-qty-btn" data-cart-qty-minus data-key="${escapeHtml(item.key)}" aria-label="Decrease quantity">&minus;</button>
                <span class="cart-item-qty-value">${item.quantity}</span>
                <button type="button" class="cart-item-qty-btn" data-cart-qty-plus data-key="${escapeHtml(item.key)}" aria-label="Increase quantity">+</button>
              </div>
              <p class="cart-item-price">${fmtMoney(item.final_line_price)}</p>
            </div>
          </div>
        </div>`;
    }).join('');

    if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);

    if (savingsEl) {
      if (cart.total_discount > 0) {
        savingsEl.style.display = 'block';
        savingsEl.textContent = `You're saving ${fmtMoney(cart.total_discount)}`;
      } else {
        savingsEl.style.display = 'none';
      }
    }
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
      return cart;
    } catch (e) {
      console.warn('Cart fetch failed', e);
    }
  }

  /* ── ADD TO CART ────────────────────────── */
  function initATC() {
    $$('[data-product-form]').forEach(form => {
      const btn = form.querySelector('[data-atc-btn]');
      if (!btn) return;
      const label = btn.dataset.label || btn.textContent.trim() || 'Add to Cart';

      form.addEventListener('submit', async e => {
        e.preventDefault();
        if (btn.disabled || cartBusy) return;
        cartBusy = true;
        btn.textContent = 'Adding...';
        btn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          });
          const data = await res.json();

          if (!res.ok) {
            const message = (data && (data.description || data.message)) || 'Could not add to cart';
            throw new Error(message);
          }

          btn.textContent = 'Added!';

          // Open the shared cart drawer and let it fetch the fresh cart state
          if (window.openCart) window.openCart();

          setTimeout(() => {
            btn.textContent = label;
            btn.disabled = false;
            cartBusy = false;
          }, 1800);
        } catch (err) {
          console.error(err);
          btn.textContent = 'Try again';

          setTimeout(() => {
            btn.textContent = label;
            btn.disabled = false;
            cartBusy = false;
          }, 2000);
        }
      });
    });
  }

  /* ── SIZE BUTTONS ───────────────────────── */
  function initSizeSelect() {
    $$('.size-options').forEach(wrap => {
      $$('.size-btn', wrap).forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('unavailable')) return;
          $$('.size-btn', wrap).forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const variantId = btn.dataset.variantId;
          if (variantId) {
            const hiddenInput = $('input[name="id"]');
            if (hiddenInput) hiddenInput.value = variantId;
          }
        });
      });
    });
  }

  /* ── QTY SELECTOR (product page stepper) ── */
  function initQty() {
    $$('.qty-wrap').forEach(wrap => {
      const input = $('input[name="quantity"]', wrap);
      if (!input) return;
      $('[data-minus]', wrap)?.addEventListener('click', () => { if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1; });
      $('[data-plus]',  wrap)?.addEventListener('click', () => { input.value = parseInt(input.value) + 1; });
    });
  }

  /* ── GALLERY ────────────────────────────── */
  function initGallery() {
    const main   = $('#main-img');
    const thumbs = $$('.product-thumb');
    if (!main) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        if (src) { main.style.opacity = '0'; setTimeout(() => { main.src = src; main.style.opacity = '1'; }, 180); main.style.transition = 'opacity 0.18s ease'; }
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  /* ── STICKY HEADER ──────────────────────── */
  function initStickyHeader() {
    const header = $('.site-header');
    if (!header) return;
    window.addEventListener('scroll', () => { header.classList.toggle('scrolled', window.scrollY > 40); }, { passive: true });
  }

  /* ── SCROLL REVEAL ──────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) { $$('.reveal').forEach(el => el.classList.add('visible')); return; }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });
    $$('.reveal').forEach(el => obs.observe(el));
  }

  /* ── HERO PARALLAX ──────────────────────── */
  function initHeroParallax() {
    const bg = $('.hero-bg');
    if (!bg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    bg.classList.add('loaded');
    let raf;
    window.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y < window.innerHeight) bg.style.transform = `translateY(${y * 0.2}px)`;
      });
    }, { passive: true });
  }

  /* ── ANNOUNCEMENT CLOSE ─────────────────── */
  function initAnnouncement() {
    const close = $('.announcement-close');
    const bar   = $('.announcement-bar');
    close?.addEventListener('click', () => bar?.remove());
  }

  /* ── FILTERS (collection) ───────────────── */
  function initFilters() {
    $$('.filter-option input').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const params = new URLSearchParams(window.location.search);
        // Simple filter: add tag param
        const tag = checkbox.value;
        const tags = params.getAll('tag');
        if (checkbox.checked) { tags.push(tag); } else { const idx = tags.indexOf(tag); if (idx > -1) tags.splice(idx, 1); }
        params.delete('tag');
        tags.forEach(t => params.append('tag', t));
        window.location.search = params.toString();
      });
    });
    const sortSelect = $('.sort-select');
    sortSelect?.addEventListener('change', () => {
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSelect.value);
      window.location.search = params.toString();
    });
  }

  /* ── WISHLIST TOGGLE ────────────────────── */
  function initWishlist() {
    $$('.btn-wishlist').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.classList.toggle('active');
        btn.innerHTML = btn.classList.contains('active') ? '♥' : '♡';
      });
    });
  }

  /* ── INIT ───────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initNavDrawer();
    initCartDrawer();
    initATC();
    initSizeSelect();
    initQty();
    initGallery();
    initStickyHeader();
    initReveal();
    initHeroParallax();
    initAnnouncement();
    initFilters();
    initWishlist();
    refreshCart();
  });

  document.addEventListener('cart:refresh', () => refreshCart());

})();
